import React from 'react';
import './styles.scss';
import { Text } from '../../text/Text.tsx';

import IRunningman from '../../../resource/runningman.gif';
import { formatContent } from '../../../utils/contentUtils.tsx';
import { appVersion } from '../../../config/version.ts';

type PopupProps = {
  onClose: () => void;
};

function TeamsContact() {
  const email = "danghuyson@outlook.com";
  const teamsLink = `msteams:/l/chat/0/0?users=${email}`;

  return (
    <a href={teamsLink} className="teams-link">
      <Text variant="body">Meet me on Teams</Text>
    </a>
  );
}

export const AboutPopup: React.FC<PopupProps> = ({ onClose }) => {
  const showingContent = () => {
    return (
      <div className="about-wrapper">
        <div className="about-content">
          <div className="about-left-col">
            <div className="image-container">
              <img
                className="about-image"
                src={IRunningman}
                alt="Running Man"
              />
            </div>

            <div className="win98-inset-box version-box">
              <Text style={{ fontStyle: 'italic', fontSize: 14 }} variant="body">
                {'Version: ' + appVersion}
              </Text>
              <span className="check-icon">✔</span>
            </div>
          </div>
          <div className="about-info">
            <Text variant="title3" style={{ fontSize: 24, marginBottom: 4 }}>Son Dang Huy</Text>
            <Text variant="body" style={{ fontSize: 18, marginBottom: 4 }}>Born: 1991</Text>
            <Text variant="body" style={{ fontSize: 18, marginBottom: 8 }}>Location: Ho Chi Minh City, Vietnam</Text>

            <fieldset className="win98-fieldset">
              <legend><Text variant="body" style={{ fontSize: 16 }}>Contact Info</Text></legend>
              <div className="fieldset-content">
                <Text variant="body" style={{ fontSize: 18 }}>Teams: <TeamsContact /></Text>
                <Text variant="body" style={{ fontSize: 18, marginTop: 4 }}>Phone: +84-97-616-2761</Text>
              </div>
            </fieldset>
          </div>
        </div>

        <div className="about-footer">
          <Text style={{ fontStyle: 'italic', fontSize: 18, textAlign: 'center' }} variant="body">
            Hope to see you one day..
          </Text>
        </div>
      </div>
    );
  };
  return (
    <div className="win98-popup about-popup-container">
      <div className="popup-header">
        <Text variant="title3" style={{ color: 'white', fontWeight: 'bold' }}>About me</Text>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="popup-body">{showingContent()}</div>
    </div>
  );
};
